import * as rmd from 'material-ui';
import React from "react";

class WHPicker extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            supressHeader: props.suppressHeader == true,
            customTitle: props.customTitle || ''
        }
    }

    handleOnBlur = (e) => {
        let {supressHeader, customTitle} = this.state;

        if (!supressHeader) {
            this.props.onChange('customTitle', customTitle);
        } else {
            this.props.onChange('customTitle', null);
        }

    }
    onChange = (e) => {
        this.setState({customTitle: e.target.value});
    }

    handleSupressHeaderToggle = (e, value) => {
        let {supressHeader, customTitle} = this.state;

        this.setState({supressHeader: !!value})

        if (value) {
            this.props.onChange({'suppressHeader': true, 'customTitle': null});
        } else {
            this.props.onChange({'suppressHeader': null, 'customTitle': this.state.customTitle});
        }
    }
    render() {
        let {supressHeader, label, url} = this.state;
 
        return (
            <div >
                <rmd.Toggle
                    label="Suppress header"
                    onToggle={this.handleSupressHeaderToggle}
                    toggled={supressHeader} />
                {!supressHeader && <rmd.TextField
                    value={this.state.customTitle || ""}
                    onChange={this.onChange}
                    onBlur={this.handleOnBlur}
                    errorText={this.props.error}
                    floatingLabelText="Override default title" /> }
            </div>
        );
    }
}

export default WHPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/WidgetHeaderPicker.js
 **/